var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pt-14"},[_c('page-title',[_vm._v("Batman: The Animated Series")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }